import type { RootStoreState } from "@store/types";

export const selectIsUserDataFetching = (state: RootStoreState): boolean => state.loyaltyCore.isUserDataFetching;
